<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17ujbSP/tc-custom/9781467461214.jpg?1728069373410" alt="This image is the cover for the book Decolonizing Christianity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Decolonizing Christianity
      </h1>
      <p class="bookDescription body article font2">
        <p><i>“How curiously different is this white God from the one preached by Jesus who understood faithfulness by how we treat the hungry and thirsty, the naked and alien, the incarcerated and infirm. This white God of empire may be appropriate for global conquerors who benefit from all that has been stolen and through the labor of all those defined as inferior; but such a deity can never be the God of the conquered.”</i> </p><p>Echoing James Cone’s 1970 assertion that white Christianity is a satanic heresy, Miguel De La Torre argues that whiteness has desecrated the message of Jesus. In a scathing indictment, he describes how white American Christians have aligned themselves with the oppressors who subjugate the “least of these”—those who have been systemically marginalized because of their race, ethnicity, and socioeconomic status—and, in overwhelming numbers, elected and supported an antichrist as president who has brought the bigotry ingrained in American society out into the open. </p><p>With this follow-up to his earlier <i>Burying White Privilege</i>, De La Torre prophetically outlines how we need to decolonize Christianity and reclaim its revolutionary, badass message. Timid white liberalism is not the answer for De La Torre—only another form of complicity. Working from the parable of the sheep and the goats in the Gospel of Matthew, he calls for unapologetic solidarity with the sheep and an unequivocal rejection of the false, idolatrous Christianity of whiteness.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Miguel A. De La Torre
      </h2>
      
      <p class="authorDescription body article">&#160;&#160;<B>Miguel A. De La Torre</B>&#160;is professor of social ethics and Latinx studies at the Iliff School of Theology in Denver. He has published over forty-one books, including&#160;<I>Burying White Privilege: Resurrecting a Badass Christianity</I>&#160;and&#160;<I>Reading the Bible from the Margins</I>. His commentary has appeared in prominent media outlets, including CNN, Telemundo, NPR,&#160;<I>Time</I>&#160;magazine, and many others, both domestic and international.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15faef22